import React from 'react';
import {CardActions,Card,CardTitle,Button} from 'react-md';
//CSS Import
import '../../css/SplashScreen.css'
import { AppProperties } from '../../common/functions';

const testTimerExpired = function(props) {
    const appProperties = AppProperties();
    
    function QuizList(){
        console.log("Close");
        props.history.push("/");

    }

    return  <Card  className="md-block-centered splashScreencontainer d-flex flex-column">
                <CardTitle className="splashCardTitle" title={"Sorry test timer has expired!"} />
                {
                    appProperties.enableLTI?null:
                    <CardActions centered>
                        <Button flat primary swapTheming onClick={QuizList}>Close</Button>
                    </CardActions>
                }
               
            </Card>


};


export default testTimerExpired;
